import {useCallback} from 'react';
import {useDeleteNorafUpdateByAgentIdMutation} from 'services/agent';

export const useDeleteNorafUpdateByAgentId = () => {
  const [deleteByAgentId] = useDeleteNorafUpdateByAgentIdMutation();

  return useCallback(
    (agentId: string) => {
      return deleteByAgentId(agentId).unwrap();
    },
    [deleteByAgentId],
  );
};
